module.exports = __webpack_public_path__ + "img/hourglass-purple.3541530d.svg";